export const NUMBER_OF_TYPING_AGENT_DOTS_SHOWN = 3
export const NUMBER_OF_OFFLINE_AVATARS_SHOWN = 3
export const FADE_TRANSITION_TIME = 300
export const RIGHT_BLOCK_MAX_WIDTH = 110
export const CHAT_TOP_WRAPPER_HEIGHT = 88
